module.exports = __webpack_public_path__ + "img/logo.b2a951d1.png";